// import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import FormInput from '../../../../components/FormInput'
import WrapperButton from '../../../../components/WrapperButton'
import { RootState } from '../../../../redux/store'
import { StateType, InputTypes } from '../../../../types/components'
import { Heading } from '../styles'
import { AddressWrapper } from './styles'

const State = ({ formValues, errors, handleForm, handleSubmit }: StateType) => {
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)

	return (
		<AddressWrapper>
			<Heading>{translations.YOUR_STATE}</Heading>

			<>
				<FormInput
					marginTop="inherit"
					type={InputTypes.TEXT}
					label={translations.STATE}
					value={formValues.state}
					name="state"
					handleChange={(e) => handleForm(e)}
					errorMessage={errors.state}
					// maxlength={6}
					autofocus={false}
					inputmode="text"
				/>
				<WrapperButton
					isLoading={metaData.isLoading}
					buttonClickHandler={handleSubmit}
					isEnabled={formValues.state?.length >= 3 ? true : false}
					btnText={translations.CONTINUE}
				/>
			</>
		</AddressWrapper>
	)
}

export default State
